import { IntegrationSetupPayload, LinkingFlowPageEnum, NextPagePayloadInfo } from "../../config/types";
import useAgentHandlerLinkModalContext from "../context/useAgentHandlerLinkModalContext";
import LoadingScreen from "../interstitials/LoadingScreen";
import TryAgainLaterScreen from "../interstitials/TryAgainLaterScreen";
import ConnectedScreen from "./ConnectedScreen";
import ConnectorSetupPageRoot from "./connector-setup/ConnectorSetupPageRoot";
import IntegrationAuthChoiceScreen from "./IntegrationAuthChoiceScreen";
import TermsOfServicePage from "./TermsOfService";
import ErrorRemediationScreensContainer from "./detailed-error-messages/ErrorRemediationScreensContainer";
import useStepTelemetry from "./hooks/useStepTelemetry";

type PageSwitcherProps = {
  isLoading: boolean;
  customLoadingText: string;
  customLoadingSubText: string;
  currentPage: LinkingFlowPageEnum;
  currentLinkPayload: NextPagePayloadInfo;
  currentLinkTranslatedLanguageData: { [key: string]: string };
};

const PageSwitcher = ({
  isLoading,
  customLoadingText,
  customLoadingSubText,
  currentPage,
  currentLinkPayload,
}: PageSwitcherProps) => {

  const { translate, onExit } =
    useAgentHandlerLinkModalContext();

  useStepTelemetry({ isLoading, currentPage, currentLinkPayload });

  if (isLoading) {
    return (
      <LoadingScreen
        customText={customLoadingText}
        customSubText={customLoadingSubText}
        connector={currentLinkPayload?.connector}
      />
    );
  }

  switch (currentPage) {

    case LinkingFlowPageEnum.LINKING_FLOW_AUTH_CHOICE:
      return <IntegrationAuthChoiceScreen linkingFlowPayload={currentLinkPayload} />;

    case LinkingFlowPageEnum.LINKING_FLOW_CONNECTOR_SETUP:
      return <ConnectorSetupPageRoot linkingFlowPayload={currentLinkPayload as IntegrationSetupPayload} />;

    case LinkingFlowPageEnum.LINKING_FLOW_TERMS_OF_SERVICE:
      return <TermsOfServicePage linkingFlowPayload={currentLinkPayload} />;

    case LinkingFlowPageEnum.LINKING_FLOW_SUCCESS:
      return <ConnectedScreen linkingFlowPayload={currentLinkPayload} />;

    case LinkingFlowPageEnum.LINKING_FLOW_DETAILED_ERROR_MESSAGES:
      return <ErrorRemediationScreensContainer linkingFlowPayload={currentLinkPayload} />;

    case LinkingFlowPageEnum.LINKING_FLOW_EXPIRED_TOKEN:
    case LinkingFlowPageEnum.LINKING_FLOW_FAILED:
      return <TryAgainLaterScreen onExit={onExit} translate={translate} />;
    default:
      return (
        <LoadingScreen
          customText={customLoadingText}
          customSubText={customLoadingSubText}
          connector={currentLinkPayload?.connector}
        />
      );
  }
};

export default PageSwitcher;
